app.directive("acEditor", ['$rootScope','AtlasNotification','NetworkService', function($rootScope, AtlasNotification, NetworkService) {
    return {
        link: function(scope, element, attributes) {
            var id = attributes.id;
            var modelName = attributes.acModel;
            
            var toolbarOptions = [
                ['bold', 'italic', 'underline', 'strike'], // toggled buttons
                ['blockquote', 'code-block'],

                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'indent': '-1' }, { 'indent': '+1' }], // outdent/indent

                [{ 'header': [1, 2, 3] }],

                [{ 'color': [] }, { 'background': [] }], // dropdown with defaults from theme
                [{ 'align': [] }],

                ['clean']
            ];
            
            if(scope.saveButtonClicked != undefined){
                toolbarOptions.push(['save'])
            }
            
            if(attributes.acPostModel != undefined){
                toolbarOptions.push(['save'])
                scope.saveButtonClicked = function(){
                    var data = "";
                    eval('data = scope.'+attributes.acPostModelData)
                    NetworkService.callOperation("post", {model:attributes.acPostModel, data:data}, function(response){
                            AtlasNotification.info("Content-Objekt erfolgreich gespeichert")
                    })
                   
                }
            }
            
            
            var editor = new Quill(element[0], {
                modules: {
                    toolbar: toolbarOptions
                },
                theme: 'snow'
            });
            
            scope.quill = editor;

            scope.disableSave = function(){
                $(".ql-save").attr("disabled", true)
            }
            
            scope.enableSave = function(){
                $(".ql-save").attr("disabled", false)
            }
            if(scope.editors == undefined){
                scope.editors = {};
            }
            scope.a = false;
            gui.addTextField(id, scope.quill)
            if(true){
                
                scope.$watch(modelName, function (newValue, oldValue, scope) {
                    if(scope.a){
                        eval("editor.root.innerHTML = '"+newValue+"'")
                    }else{
                        scope.a = true;
                    }
                    
                });
                //eval("scope." + modelName + " = '" + editor.root.innerHTML + "'");
                //console.log("editor.root.innerHTML = scope."+modelName)
                //eval("editor.root.innerHTML = scope."+modelName)
            }

            scope.quill.on('text-change', function(delta, oldDelta, source) {
                
                if(modelName){
                    eval("scope." + modelName + " = '" + editor.root.innerHTML + "'");
                    scope.a = false;
                    scope.$apply()
                }
                if(scope.editorChanged != undefined){
                    scope.editorChanged()
                }
            });
            
            if(scope.saveButtonClicked != undefined){
                var customButton = document.querySelector('.ql-save');
                customButton.setAttribute("title", "Änderungen speichern")
                
                customButton.addEventListener('click', function() {
                    scope.saveButtonClicked(scope.quill.root.innerHTML);
                });
            }
            
        }
    }
}]);